#import "../line/lineInfo.gql"

fragment downtimeBlockInfo on DowntimeBlock {
  endsAt
  id
  lockedOnSchedule
  reason
  reasonCode
  startsAt
  line {
    ...lineInfo
  }
  overlappingPlannedBreaks {
    plannedBreakName
    duration
  }
}
